/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnSecurity.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnSecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnSecurity-view">
        <Helmet>
          <title>系統安全 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnSecurity-first">
          <div className="CnSecurity-content">
            <div className="CnSecurity-cardContainer">
              <div className="CnSecurity-cardIcn" />
              <div className="CnSecurity-heading">付款处理</div>
            </div>

            <div className="CnSecurity-stripeContainer">
              <div className="CnSecurity-stripeLogo" />
              <div className="CnSecurity-txt">
                CheckPlus 透过 Stripe 处理我们的所有信用卡交易。
                <Link to="/CnStripe">
                  <div className="CnSecurity-learnmoreContainer">
                    <div className="CnSecurity-learnmore">进一步了解</div>
                    <div className="CnSecurity-arrow" />
                  </div>
                </Link>
              </div>
            </div>

            <div className="CnSecurity-hsbcContainer">
              <div className="CnSecurity-hsbcLogo" />
              <div className="CnSecurity-txt">
                CheckPlus 与 HSBC 汇丰合作，令捐款者可以在平台上透过 PayMe
                付款或捐款。
              </div>
            </div>
          </div>
        </div>

        <div className="CnSecurity-second">
          <div className="CnSecurity-content">
            <div className="CnSecurity-serverContainer">
              <div className="CnSecurity-serverIcn" />
              <div className="CnSecurity-heading">数据处理</div>
            </div>

            <div className="CnSecurity-stripeContainer">
              <div className="CnSecurity-awsLogo" />
              <div className="CnSecurity-txt">
                CheckPlus 使用 Amazon Web Services（AWS）
                并在符合‍ISO27001的安全标准下运行我们服务的数据。
              </div>
              <div className="CnSecurity-tickContainer">
                <div className="CnSecurity-tickIcn" />
                <div className="CnSecurity-tickTxt">HTTPS</div>
              </div>
              <div className="CnSecurity-tickContainer">
                <div className="CnSecurity-tickIcn" />
                <div className="CnSecurity-tickTxt">SSL</div>
              </div>
              <div className="CnSecurity-tickContainer">
                <div className="CnSecurity-tickIcn" />
                <div className="CnSecurity-tickTxt">ISO27001 Certified</div>
              </div>
            </div>
          </div>
        </div>

        <div className="CnSecurity-footer">
          <div className="CnSecurity-footerNav">
            <Link to="/CnTeam">
              <div className="CnSecurity-footerNavItem">创办人的故事</div>
            </Link>
            <a
              href="https://checkplushk.zendesk.com/hc"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="CnSecurity-footerNavItem">常见问题</div>
            </a>
            <Link to="/CnContact">
              <div className="CnSecurity-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnSecurity-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnSecurity-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnSecurity-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnSecurity;
